import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from './config/config';

// Import namespace files directly
// English translations
import enCommon from './locales/en/namespaces/common.json';
import enHome from './locales/en/namespaces/home.json';
import enAuth from './locales/en/namespaces/auth.json';
import enDashboard from './locales/en/namespaces/dashboard.json';
import enTransactions from './locales/en/namespaces/transactions.json';
import enWallets from './locales/en/namespaces/wallets.json';
import enAssets from './locales/en/namespaces/assets.json';
import enInstallments from './locales/en/namespaces/installments.json';
import enUser from './locales/en/namespaces/user.json';
import enNavigation from './locales/en/namespaces/navigation.json';
import enSchemas from './locales/en/namespaces/schemas.json';
import enForms from './locales/en/namespaces/forms.json';
import enSettings from './locales/en/namespaces/settings.json';
import enCategorySelector from './locales/en/namespaces/categorySelector.json';
import enLoan from './locales/en/namespaces/loan.json';
import enUpgrade from './locales/en/namespaces/upgrade.json';
import enComponent from './locales/en/namespaces/component.json';
import enOverview from './locales/en/namespaces/overview.json';
import enBudget from './locales/en/namespaces/budget.json';
import enCategories from './locales/en/namespaces/categories.json';
import enTransactionTypeSelector from './locales/en/namespaces/transactionTypeSelector.json';
import enOnboarding from './locales/en/namespaces/onboarding.json';

// Vietnamese translations
import viCommon from './locales/vi/namespaces/common.json';
import viHome from './locales/vi/namespaces/home.json';
import viAuth from './locales/vi/namespaces/auth.json';
import viDashboard from './locales/vi/namespaces/dashboard.json';
import viTransactions from './locales/vi/namespaces/transactions.json';
import viWallets from './locales/vi/namespaces/wallets.json';
import viAssets from './locales/vi/namespaces/assets.json';
import viInstallments from './locales/vi/namespaces/installments.json';
import viUser from './locales/vi/namespaces/user.json';
import viNavigation from './locales/vi/namespaces/navigation.json';
import viSchemas from './locales/vi/namespaces/schemas.json';
import viForms from './locales/vi/namespaces/forms.json';
import viSettings from './locales/vi/namespaces/settings.json';
import viCategorySelector from './locales/vi/namespaces/categorySelector.json';
import viLoan from './locales/vi/namespaces/loan.json';
import viUpgrade from './locales/vi/namespaces/upgrade.json';
import viComponent from './locales/vi/namespaces/component.json';
import viOverview from './locales/vi/namespaces/overview.json';
import viBudget from './locales/vi/namespaces/budget.json';
import viCategories from './locales/vi/namespaces/categories.json';
import viTransactionTypeSelector from './locales/vi/namespaces/transactionTypeSelector.json';
import viOnboarding from './locales/vi/namespaces/onboarding.json';

// Define resources with namespaces
const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    schemas: enSchemas,
    home: enHome,
    auth: enAuth,
    dashboard: enDashboard,
    transactions: enTransactions,
    wallets: enWallets,
    assets: enAssets,
    installments: enInstallments,
    user: enUser,
    forms: enForms,
    settings: enSettings,
    categorySelector: enCategorySelector,
    loan: enLoan,
    upgrade: enUpgrade,
    component: enComponent,
    overview: enOverview,
    budget: enBudget,
    categories: enCategories,
    transactionTypeSelector: enTransactionTypeSelector,
    onboarding: enOnboarding
  },
  vi: {
    common: viCommon,
    navigation: viNavigation,
    schemas: viSchemas,
    home: viHome,
    auth: viAuth,
    dashboard: viDashboard,
    transactions: viTransactions,
    wallets: viWallets,
    assets: viAssets,
    installments: viInstallments,
    user: viUser,
    forms: viForms,
    settings: viSettings,
    categorySelector: viCategorySelector,
    loan: viLoan,
    upgrade: viUpgrade,
    component: viComponent,
    overview: viOverview,
    budget: viBudget,
    categories: viCategories,
    transactionTypeSelector: viTransactionTypeSelector,
    onboarding: viOnboarding
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'vi',
    debug: config.environment.isDevelopment,
    ns: [
      'common', 'navigation', 'schemas', 'home', 'auth',
      'dashboard', 'transactions', 'wallets', 'assets',
      'installments', 'user', 'forms', 'settings',
      'categorySelector', 'loan', 'upgrade', 'component', 'overview', 'budget', 'categories',
      'transactionTypeSelector', 'onboarding'
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage']
    },
  });

// Force Vietnamese language if no language is set in localStorage
if (!localStorage.getItem('language')) {
  i18n.changeLanguage('vi');
  localStorage.setItem('language', 'vi');
}

export default i18n;